<template>
  <!--dont do preventDefault, otherwise, text input wont work-->
  <div :style="windowStyle" class="v-window-dragger">
    <div v-if="iAmButton || minimizeMe" 
      style="position:absolute;z-index:1" 
      :class="{'w-button':true}"
      @click.prevent="clickIcon" 
      @dblclick.prevent.stop="doubleClickIcon">
      <slot name="button" />
    </div>
    <div v-show="!(iAmButton || minimizeMe)" 
      :style="{position:'absolute','z-index':0,opacity:hasMoved ? 0.6 : 1.0}">
      <div ref="vWindow" :class="{'v-window':true,base:defaultStyle}">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    noDrag: {
      type: Boolean,
      default: () => { return false; }
    },
    isButton: {
      type: Boolean | String,
      default: () => { return false; }
    },
    minimized: {
      type: Boolean | String,
      default: () => { return false; }
    },
    locatedAt: {
      type: String, // center | top-center | bottom-center | bottom-right | bottom-left
      default: () => { return null; }
    },
    x: {
      type: Number | String,
      default: () => { return 10; }
    },
    y: {
      type: Number | String,
      default: () => { return 10; }
    },
    width: {
      type: Number | String,
      default: () => { return 'auto'; }
    },
    height: {
      type: Number | String,
      default: () => { return 'auto'; }
    }
  },
  data() {
    return {
      moving: false,
      lastX: this.x,
      lastY: this.y,
      style: {
        left: parseFloat(this.x+''), // important to convert string to number
        top: parseFloat(this.y+''),
        width: (this.width+'').match(/auto/i) ? 'auto' : parseFloat(this.width+''),
        height: (this.height+'').match(/auto/i) ? 'auto' : parseFloat(this.height+''),
        zIndex: 0,
        cursor: 'default'
      },
      buttonStyle: {
        position: 'absolute',
        'z-index': 1
      },
      defaultStyle: true,
      iAmButton: false,
      minimizeMe: false,
      clickIconCount: 0,
      hasMoved: false
    }
  },
  computed: {
    windowStyle() {
      let s = {
        position: 'absolute',
        'pointer-events': 'auto',
        left: this.style.left + 'px',
        top: this.style.top + 'px',
        width: isNaN(this.style.width) ? 'auto' : (this.width + 'px'),
        height: isNaN(this.style.height) ? 'auto' : (this.height + 'px'),
        'z-index': this.style.zIndex,
        cursor: this.style.cursor
      };
      if (this.moving) {
        s['user-select'] = 'none';
        //s.opacity = 0.3;
        //s['pointer-events'] = 'none',
      }
      return s;
    },
    /*buttonStyle() {
      return {
        position: 'absolute',
        'z-index': 1
      };
    },*/
    BinderRect() {
      return this.$el.parentElement.getBoundingClientRect();
    }
  },
  mounted() {
    let self = this;
    this.$nextTick(() => {
      self.defaultStyle = !(this.noStyle+'').match(/true/i);
      self.iAmButton = !(this.isButton+'').match(/false/i);
      self.minimizeMe = !(self.minimized+'').match(/false/i);
      this.locateMe(this.locatedAt);
    });
    let fwBtn = this.$el.querySelector('.v-window-min-button');
    if (fwBtn) {
      fwBtn.addEventListener('click', this.clickIcon);
      fwBtn.addEventListener('dblclick', this.doubleClickIcon);
    }
    if (!this.noDrag) {
      this.$el.addEventListener('mousedown', this.startMove);
      this.$el.addEventListener('touchstart', this.startMove, {passive:true});
      //@mousedown.stop="startMove"
      //@touchstart.stop="startMove"
    } else {
      this.$el.addEventListener('click', this.bringToTop);
      this.$el.addEventListener('touchstart', this.bringToTop, {passive:true});
    }
  },
  beforeDestroy() {
    if (!this.noDrag) {
      this.$el.removeEventListener('mousedown', this.startMove);
      this.$el.removeEventListener('touchstart', this.startMove, {passive:true});
    } else {
      this.$el.removeEventListener('click', this.bringToTop);
      this.$el.removeEventListener('touchstart', this.bringToTop, {passive:true});
    }
  },
  methods: {
    locateMe(location) {
      if (!location) return;
      location = location.toLowerCase();
      setTimeout(() => {
        let pw, ph, cw, ch;
        pw = this.$parent.$el.clientWidth || 
            (document.body.clientWidth + document.body.scrollLeft) ||
            window.innerWidth;
        ph = this.$parent.$el.clientHeight ||
            (document.body.clientHeight + document.body.scrollTop) ||
            window.innerHeight;
        cw = this.$refs.vWindow.clientWidth;
        ch = this.$refs.vWindow.clientHeight;
        if (this.noDrag) {
          if (location=='center' || location=='center-center') {
            this.$el.style.left = 'calc(50% - ' + (cw / 2) + 'px)';
            this.$el.style.top = 'calc(50% - ' + (ch / 2) + 'px)';
          } else if (location=='top-center') {
            this.$el.style.left = 'calc(50% - ' + (cw / 2) + 'px)';
            this.$el.style.top = 0;
          } else if (location=='bottom-center') {
            this.$el.style.left = 'calc(50% - ' + (cw / 2) + 'px)';
            this.$el.style.top = ph - ch - 1;
          } else if (location=='bottom-left') {
            this.$el.style.left = 0
            this.$el.style.top = ph - ch - 1;
          } else if (location=='bottom-right') {
            this.$el.style.left = 'calc(100% - ' + (cw -1) + 'px)';
            this.$el.style.top = ph - ch - 1;
          }
        } else {
          if (location=='center' || location=='center-center') {
            this.style.left = (pw - cw) / 2;
            this.style.top = (ph - ch) / 2;
          } else if (location=='top-center') {
            this.style.left = (pw - cw) / 2;
            this.style.top = 0;
          } else if (location=='bottom-center') {
            this.style.left = (pw - cw) / 2;
            this.style.top = ph - ch - 1;
          } else if (location=='bottom-left') {
            this.style.left = 0
            this.style.top = ph - ch - 1;
          } else if (location=='bottom-right') {
            this.style.left = pw - cw - 1;
            this.style.top = ph - ch - 1;
          }
        }
        this.$emit('visible', this);
      }, 250);
      // wait a while for UI to load and make visible, otherwise
      // the clientWidth/clientHeight is could be 0 that is wrong
    },
    zTopmost() {
      let z = 0;
      if (this.$el) {
        let children = [ ...this.$el.parentElement.childNodes ];
        children.forEach((c) => {
          z = Math.max(z,parseInt('0' + (c.style ? c.style.zIndex : '0')));
        });
      }
      return z + 1;
    },
    bringToTop() {
      this.style.zIndex = this.zTopmost();
    },
    startMove(event) {
      event.stopPropagation();
      if (this.noDrag) return;
      // dont preventDefault if target is input element
      let target = event.target.tagName;
      if (!(target.match(/input|textarea/i))) {
        event.preventDefault();
        event.stopPropagation();
      }
      this.hasMoved = false;
      this.moving = true;
      this.lastX = event.pageX;
      this.lastY = event.pageY;
      this.style.zIndex = this.zTopmost();
      this.style.cursor = 'move';
      document.addEventListener('mousemove', this.move);
      document.addEventListener('mouseup', this.stopMove, true);
      // a workaround for preventing from bubbling click to child
      document.addEventListener('click', this.stopDrag, true);
      document.addEventListener('touchmove', this.move);
      document.addEventListener('touchstop', this.stopMove, true);
    },
    move(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.moving) {
        let dx = event.pageX - this.lastX;
        let dy = event.pageY - this.lastY;
        this.style.left += dx;
        this.style.top += dy;  
        this.lastX = event.pageX;
        this.lastY = event.pageY;
        this.hasMoved = this.hasMoved || (Math.abs(dx)>1 || Math.abs(dy)>1);
      }
    },
    stopMove(event) {
      if (this.noDrag) return;
      document.removeEventListener('mousemove', this.move);
      document.removeEventListener('mouseup', this.stopMove, true);
      document.removeEventListener('touchmove', this.move);
      document.removeEventListener('touchstop', this.stopMove, true);
      this.moving = false;
      this.style.cursor = 'default';
      let target = event.target.tagName;
      if (this.hasMoved && !(target.match(/input|textarea/i))) {
        //to stop bubbling of mousedown
        event.preventDefault();
        event.stopPropagation();
      }
    },
    stopDrag(event) {
      if (this.noDrag) return;
      document.removeEventListener('click', this.stopDrag, true);
      let target = event.target.tagName;
      if (this.hasMoved && !(target.match(/input|textarea/i))) {
        //to stop bubbling of click
        event.preventDefault();
        event.stopPropagation();
        this.hasMoved = false;
      }
    },
    clickIcon(event) {
      event.preventDefault;
      event.stopPropagation;
      this.clickIconCount++;
      if (this.clickIconCount>1) {
        return false;
      }
      let self = this;
      setTimeout(() => {
        if (self.clickIconCount==1) {
          self.doClickIcon();
        }
        self.clickIconCount = 0;
      }, 300);
    },
    doClickIcon() {
      if (!this.isButton) {
        this.minimizeMe = !this.minimizeMe;
      }
      this.$emit('click');
    },
    doubleClickIcon(event) {
      event.preventDefault;
      event.stopPropagation;
      this.style.left = parseFloat('0' + this.x);
      this.style.top = parseFloat('0' + this.y);
    }
  },
  watch: {
    locatedAt(value) {
      if (value) {
        this.locateMe(value);
      }
    }
  }
}
</script>

<style>
  .fw-shadow {
    box-shadow: 0 3px 5px -1px rgba(0,0,0,.2),
                0 6px 10px 0 rgba(0,0,0,.14),
                0 1px 18px 0 rgba(0,0,0,.12);
  }
  .v-window.base {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 2px;
    background-color: rgba(255,255,255,0.9);
    box-shadow: 1px 1px 1px rgba(0,0,0,.5);
  }
  /*.v-window {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }*/
  .fw-bwindow > * {
    width: 100%;
  }
  .w-button button {
    left: 0;
    top: 0;
    width: 48px;
    height: 48px;
    min-width: 48px;
    min-height: 48px;
    margin: 6px;
    border-radius: 50%;
  }
</style>
